import type {AssetRecord} from '../shared/contracts';

export function reviewFileSize(bytes:number):string{
 return bytes<1024?`${bytes} B`:bytes<1024*1024?`${(bytes/1024).toFixed(1)} KB`:`${(bytes/1024/1024).toFixed(2)} MB`;
}

/** Picker availability only; the server verifies actual retained originals. */
export function isReviewableFile(asset:Pick<AssetRecord,'mimeType'>):boolean{
 return [
  'image/jpeg','image/png','image/webp','image/gif','image/tiff', 'image/heic', 'image/heif','application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','text/plain','text/csv',
 ].includes(asset.mimeType);
}
